import React, { useEffect } from 'react';
import { HeroSection } from './components/sections/HeroSection';
import { ProblemSection } from './components/sections/ProblemSection';
import { SolutionSection } from './components/sections/SolutionSection';
import { VolumesSection } from './components/sections/VolumesSection';
import { BonusesSection } from './components/sections/BonusesSection';
import { ValueSection } from './components/sections/ValueSection';
import { ReuseSection } from './components/sections/ReuseSection';
import { OfferSection } from './components/sections/OfferSection';
import { AudienceSection } from './components/sections/AudienceSection';
import { TestimonialsSection } from './components/sections/TestimonialsSection';
import { FaqSection } from './components/sections/FaqSection';
import { LastQuestionSection } from './components/sections/LastQuestionSection';
import { FinalCtaSection } from './components/sections/FinalCtaSection';
import { SiteFooter } from './components/SiteFooter';
import { PurchasePopup } from './components/PurchasePopup';
import { initMetaPixel, PIXEL_ID } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen w-full bg-black text-carbon-200 antialiased" data-id="element-0" data-mp="3rbrayrj641gc">
      <noscript data-id="element-1" data-mp="5yi8qe3h5da">
        <img height="1" width="1" style={{
        display: 'none'
      }} alt="" src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-2" data-mp="6hp9c27i9cj" />
      </noscript>
      <div className="mx-auto w-full max-w-3xl border-x border-carbon-800 bg-carbon-950 shadow-2xl shadow-black" data-id="element-3" data-mp="33mouhn09senf">
        <div className="h-1.5 bg-accent-500" aria-hidden="true" data-id="element-4" data-mp="38m1fe27kzbnd" />
        <HeroSection data-id="element-5" data-mp="38nuodo5o27yj" />
        <main data-id="element-6" data-mp="3dkuvm2e95gr8">
          <ProblemSection data-id="element-7" data-mp="3dle3eqa6uorj" />
          <SolutionSection data-id="element-8" data-mp="3dlnukh6yz1yt" />
          <VolumesSection data-id="element-9" data-mp="3dirtwl3qlz6o" />
          <BonusesSection data-id="element-10" data-mp="nvsv37yeytxj" />
          <ValueSection data-id="element-11" data-mp="nuhged3fk1rn" />
          <ReuseSection data-id="element-12" data-mp="nv1284w7baay" />
          <OfferSection data-id="element-13" data-mp="nxwvhfx3tat2" />
          <AudienceSection data-id="element-14" data-mp="su44xiopl4fr" />
          <TestimonialsSection data-id="element-15" data-mp="stc864jdl0nw" />
          <FaqSection data-id="element-16" data-mp="swqbpg3rzfwx" />
          <LastQuestionSection data-id="element-17" data-mp="3685nh1tcguh" />
          <FinalCtaSection data-id="element-18" data-mp="35gm54lhq9kk" />
        </main>
        <SiteFooter data-id="element-19" data-mp="38ktgau95lfg" />
      </div>
      <PurchasePopup data-id="element-20" data-mp="3udaw269tuj3n" />
    </div>;
}